import type { JSX } from 'react'
import { Navigate } from 'react-router'
import useRoles from '@/hooks/useRoles'
import type { SystemUserRolesType } from '@/api/types/Organization'

interface ProtectedRouteProps {
  allowedRoles: SystemUserRolesType[]
  element: JSX.Element
}

const ProtectedRoute = ({ allowedRoles, element }: ProtectedRouteProps) => {
  const { role } = useRoles()

  if (!allowedRoles.includes(role!)) {
    return <Navigate to='/' replace />
  }

  return element
}

export default ProtectedRoute
